"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Spinner = _interopRequireDefault(require("./Spinner"));
var _reactRedux = require("react-redux");
var _CancelQuestion = _interopRequireDefault(require("./CancelQuestion"));
var _CancelConfirmation = _interopRequireDefault(require("./CancelConfirmation"));
var _selector = require("../../selectors/selector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PopupContent = function PopupContent(_ref) {
  var cancelApi = _ref.cancelApi,
    setIsClosable = _ref.setIsClosable;
  var fetching = (0, _reactRedux.useSelector)(_selector.isFetchingData);
  var addon = (0, _reactRedux.useSelector)(_selector.cancelAddon);
  var isAddonCancelled = (0, _reactRedux.useSelector)(_selector.addonCancelled);
  /**
   * listen to on fetching data to hide x button in popup
   */
  (0, _react.useEffect)(function () {
    setIsClosable(!fetching);
  }, [fetching]);
  if (fetching) return /*#__PURE__*/_react.default.createElement(_Spinner.default, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "poupcontent"
  }, !isAddonCancelled ? /*#__PURE__*/_react.default.createElement(_CancelQuestion.default, {
    expirationDate: addon.expirationDate,
    id: addon.id,
    name: addon.name,
    cancelApi: cancelApi
  }) : /*#__PURE__*/_react.default.createElement(_CancelConfirmation.default, {
    expirationDate: addon.expirationDate,
    name: addon.name,
    id: addon.id
  }));
};
PopupContent.propTypes = {
  setIsClosable: _propTypes.default.func.isRequired,
  cancelApi: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    endPoint: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = PopupContent;
exports.default = _default;